import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type SkeletonViewMode = 'grid' | 'list';

@Component({
  selector: 'app-product-card-skeleton',
  template: `
    <div
      class="skeleton"
      [class.skeleton--list]="viewMode() === 'list'"
      aria-hidden="true"
    >
      <div class="skeleton__image"></div>
      <div class="skeleton__info">
        <div class="skeleton__line skeleton__line--badge"></div>
        <div class="skeleton__line skeleton__line--name"></div>
        <div class="skeleton__line skeleton__line--meta"></div>
        <div class="skeleton__line skeleton__line--price"></div>
      </div>
    </div>
  `,
  styleUrl: './product-card-skeleton.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
})
export class ProductCardSkeletonComponent {
  viewMode = input<SkeletonViewMode>('grid');
}
